
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { SaasInstance } from '@/types/userRole';

interface InstanceOverviewTabProps {
  instance: SaasInstance;
}

const InstanceOverviewTab: React.FC<InstanceOverviewTabProps> = ({ instance }) => {
  // Use instance.domain, customDomain, or subdomain if needed
  const displayDomain = instance.customDomain || instance.domain || (instance.subdomain ? `${instance.subdomain}.referme.site` : '');
  
  // Format the date properly
  const formatDate = (dateStr: string) => {
    try {
      return new Date(dateStr).toLocaleDateString();
    } catch (e) {
      return dateStr;
    }
  };
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Instance Overview</CardTitle>
        <CardDescription>Key information about this SaaS instance</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h3 className="text-sm font-medium text-gray-500">Instance ID</h3>
            <p className="mt-1">{instance.id}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500">Status</h3>
            <p className="mt-1">
              <span className={`px-2 py-1 text-xs rounded-full ${
                instance.status === 'active' 
                  ? 'bg-green-100 text-green-800' 
                  : 'bg-red-100 text-red-800'
              }`}>
                {instance.status}
              </span>
            </p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500">Owner ID</h3>
            <p className="mt-1">{instance.ownerId || 'N/A'}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500">Plan</h3>
            <p className="mt-1 capitalize">{instance.plan}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500">Created</h3>
            <p className="mt-1">{formatDate(instance.createdAt)}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-500">Domain</h3>
            <p className="mt-1">{displayDomain}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default InstanceOverviewTab;
